<template>
  <div>

    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('action_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{ item.titre }} - {{ $t('orderaction.orderaction') }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-orderaction-show">
      <v-simple-table>
        <template slot="default">
          <thead>
          <tr>
            <th>{{ $t('global.field') }}</th>
            <th>{{ $t('global.value') }}</th>

            <th>{{ $t('global.field') }}</th>
            <th>{{ $t('global.value') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td><strong>{{ $t('orderaction.order') }}</strong></td>
            <td>
                <v-btn
                    v-if="item['orderRef']"
                    color="secondary"
                    class=""
                    @click="showHandlerLink(item['orderRef'])"
                >
                     {{ item['orderRef'].ref }}
                     <v-icon
                         right
                         dark
                     >mdi-eye
                     </v-icon>
                   </v-btn>
            </td>

            <td><strong>{{ $t('global.createdby') }}</strong></td>
            <td>
              <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
            </td>

          </tr>
          <tr>
            <td><strong>{{ $t('orderaction.type') }}</strong></td>
            <td>
              <span>{{ item['type'].name }}</span>
            </td>
            <td><strong>{{ $t('orderaction.date') }}</strong></td>
            <td>
              {{ formatDateTime(item['date'], 'long') }}
            </td>
          </tr>
          <tr>
            <td><strong>{{ $t('global.file') }}</strong></td>
            <td v-if="item['file']">
              {{item.file.filePath}}
              <v-btn
                  color="secondary"
                  class=""
                  @click="downloadFileByObject(item)"
              >
                {{ $t('global.download') }}
                <v-icon
                    right
                    dark
                >mdi-download
                </v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
            <br/>
      <v-simple-table>
        <template>
          <tbody>
          <tr>
            <td><strong>{{ $t('orderaction.content') }}</strong></td>
            <td colspan="3">
              <pre class="v">
              {{ item['content'] }}
              </pre>
            </td>
          </tr>

          <tr>
            <td><strong>{{ $t('orderaction.comment') }}</strong></td>
              <pre class = "truncate">
              {{ item['comment'] }}
              </pre>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'OrderAction';

export default {
  name: 'OrderActionShow',
  servicePrefix,
  components: {
    Loading,
    Toolbar
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('orderaction', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('orderaction', ['find']),
  },
  methods: {
    ...mapActions('orderaction', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>

<style>
pre {
  font-family: "Roboto", sans-serif;
  tab-size: 4;
  line-height: 1.5;
}
.truncate {
max-width: auto;
word-wrap: break-word;
white-space: pre-wrap;
overflow: hidden;
display: block;
}
</style>